window.theme = window.theme || {};

(function () {
  var getDrawerSectionParams = function () {
    var wrapper = document.querySelector("[data-cart-drawer]");
    if (!wrapper) return null;
    var sectionId = wrapper.getAttribute("data-section-id");
    if (!sectionId) return null;
    var sectionUrl = window.location.pathname + window.location.search;
    return { id: sectionId, url: sectionUrl };
  };

  var requestJson = function (url, options) {
    return fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        if (text) {
          try {
            data = JSON.parse(text);
          } catch (err) {
            data = null;
          }
        }
        if (!response.ok) {
          var error = new Error(response.statusText || "Request failed");
          error.status = response.status;
          error.responseJSON = data;
          error.responseText = text;
          throw error;
        }
        return data;
      });
    });
  };

  var toQueryParams = function (data) {
    var params = new URLSearchParams();
    if (!data) return params;
    Object.keys(data).forEach(function (key) {
      var value = data[key];
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          params.append(key, item);
        });
      } else if (value !== undefined && value !== null) {
        params.append(key, value);
      }
    });
    return params;
  };

  var postFormJson = function (url, data) {
    var body =
      typeof FormData !== "undefined" && data instanceof FormData
        ? data
        : toQueryParams(data);
    return requestJson(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      body: body,
    });
  };

  var getJson = function (url) {
    return requestJson(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
  };

  var getText = function (url) {
    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) {
        var error = new Error(response.statusText || "Request failed");
        error.status = response.status;
        throw error;
      }
      return response.text();
    });
  };

  var cartItemChangeQty = function (data, success, fail, finallyCb) {
    var sectionParams = getDrawerSectionParams();
    if (sectionParams && sectionParams.id) {
      data.sections = sectionParams.id;
      if (sectionParams.url) {
        data.sections_url = sectionParams.url;
      }
    }

    postFormJson("/cart/change.js", data)
      .then(function (res) {
        if (typeof success === "function") {
          success(res);
        }
      })
      .catch(function (error) {
        if (typeof fail === "function") {
          fail(error);
        }
      })
      .finally(function () {
        if (typeof finallyCb === "function") {
          finallyCb();
        }
      });
  };

  var closest = function (target, selector) {
    if (!target) return null;
    var el = target.nodeType === 3 ? target.parentElement : target;
    if (!el || !el.closest) return null;
    return el.closest(selector);
  };

  theme.Drawer = {
    isUpdating: false,

    // Markup for the suggestion cards we have already resolved. Every cart
    // mutation re-renders the drawer section with an empty container, so we
    // re-inject this instead of re-fetching the same products.
    suggestedHtml: "",

    // Bumped by every replaceDrawerContent. An in-flight section fetch
    // captures it and discards its own response if a newer swap landed
    // first, so a slow GET cannot reinstate pre-mutation HTML.
    renderGeneration: 0,

    // Focus descriptor captured before a mutation disables the control the
    // shopper was on, consumed by the next replaceDrawerContent.
    pendingFocus: null,

    // Bumped whenever a new suggestion build starts or the block is
    // invalidated (cart emptied). In-flight suggestion fetches carry the
    // value they started with and drop their response if it moved on, so a
    // slow recommendations response cannot render cards for a previous add
    // or under an emptied cart.
    recGeneration: 0,

    // Collection-rung cards from the added product's pairs-with view, held
    // until both recommendation rungs have come up dry. Cleared at the start
    // of every build and on empty cart, so one product's collection cannot
    // leak into a later add's fallback.
    collectionFallbackCards: [],

    getDrawerWrapper: function () {
      return document.querySelector("[data-cart-drawer]");
    },

    getDrawerContent: function () {
      var wrapper = theme.Drawer.getDrawerWrapper();
      if (!wrapper) return null;
      return wrapper.querySelector("[data-cart-drawer-content]");
    },

    getSectionRequestParams: function () {
      return getDrawerSectionParams();
    },

    // Records where keyboard focus sits inside the drawer so it can be
    // restored after the innerHTML swap. Reconcile-driven refreshes fire with
    // no user gesture, and letting focus fall to <body> ejects keyboard and
    // screen-reader users from an open drawer with no announcement.
    captureDrawerFocus: function (content) {
      var active = document.activeElement;
      if (!active || !content.contains(active) || !active.className)
        return null;

      var row = closest(active, ".cart-item");
      var key = row ? row.getAttribute("data-id") : null;
      var selector =
        "." + String(active.className).trim().split(/\s+/).join(".");

      return function () {
        var scope = content;
        if (key) {
          scope =
            content.querySelector('.cart-item[data-id="' + key + '"]') ||
            content;
        }
        var target = null;
        try {
          target = scope.querySelector(selector);
        } catch (err) {
          return;
        }
        if (target && target.focus) target.focus({ preventScroll: true });
      };
    },

    replaceDrawerContent: function (html) {
      var content = theme.Drawer.getDrawerContent();
      if (!content || !html) return false;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var newWrapper = parsed.querySelector("[data-cart-drawer]");
      if (!newWrapper) return false;
      var newContent = newWrapper.querySelector("[data-cart-drawer-content]");
      if (!newContent) return false;

      var restoreFocus =
        theme.Drawer.pendingFocus || theme.Drawer.captureDrawerFocus(content);
      theme.Drawer.pendingFocus = null;
      content.innerHTML = newContent.innerHTML;
      theme.Drawer.renderGeneration++;
      if (restoreFocus) restoreFocus();
      return true;
    },

    setLoadingState: function (isLoading) {
      theme.Drawer.isUpdating = !!isLoading;
      var wrapper = theme.Drawer.getDrawerWrapper();
      if (!wrapper) return;

      wrapper.classList.toggle("is-updating", theme.Drawer.isUpdating);

      var content = theme.Drawer.getDrawerContent();
      if (isLoading && content) {
        // Disabling the focused control blurs it, which would leave
        // replaceDrawerContent with nothing to capture. Record it first.
        theme.Drawer.pendingFocus = theme.Drawer.captureDrawerFocus(content);
      }

      var controls = wrapper.querySelectorAll(
        ".drawer-qty-adjust, .quantity__input",
      );
      controls.forEach(function (control) {
        control.disabled = theme.Drawer.isUpdating;
      });

      // Loading finished without a swap consuming it (e.g. the request
      // failed) - drop it so a later swap cannot act on a stale descriptor.
      if (!isLoading) theme.Drawer.pendingFocus = null;

      var removeLinks = wrapper.querySelectorAll(".cart-item-remove-container");
      removeLinks.forEach(function (link) {
        if (theme.Drawer.isUpdating) {
          link.setAttribute("aria-disabled", "true");
        } else {
          link.removeAttribute("aria-disabled");
        }
      });
    },

    // Liquid is the only line-item renderer. Every Cart API response that
    // carries `sections` swaps the server-rendered drawer in; anything that
    // does not is reconciled by re-fetching the section (reconcileCart).
    applyCartUpdate: function (cart) {
      var params = theme.Drawer.getSectionRequestParams();
      var sectionUpdated = false;

      // An emptied cart invalidates whatever we were suggesting for it -
      // the cached cards and any suggestion fetch still in flight.
      if (cart && cart.item_count === 0) {
        theme.Drawer.suggestedHtml = "";
        theme.Drawer.collectionFallbackCards = [];
        theme.Drawer.recGeneration++;
      }

      if (cart && cart.sections && params && cart.sections[params.id]) {
        sectionUpdated = theme.Drawer.replaceDrawerContent(
          cart.sections[params.id],
        );
        if (sectionUpdated) {
          theme.Drawer.restoreProductRecommendation();
        }
      }

      if (cart && typeof cart.item_count !== "undefined") {
        theme.Drawer.changeCartCount(cart.item_count);
      }

      return {
        sectionUpdated: sectionUpdated,
        hasCount: cart && typeof cart.item_count !== "undefined",
      };
    },

    // Cheap freshness check: /cart.js (~200 B gzipped) against the
    // data-cart-fingerprint stamped into the section by drawer-template.
    // Match: update the count bubble and stop - zero DOM work. Mismatch
    // (stale page, bfcache restore, missed sections payload): re-render
    // the whole drawer server-side once.
    reconcileCart: function () {
      return getJson("/cart.js")
        .then(function (cart) {
          if (!cart) return;

          theme.Drawer.changeCartCount(cart.item_count);
          if (cart.item_count === 0) {
            theme.Drawer.suggestedHtml = "";
            theme.Drawer.collectionFallbackCards = [];
            theme.Drawer.recGeneration++;
          }

          var wrapper = theme.Drawer.getDrawerWrapper();
          if (!wrapper) return;
          var stamp = wrapper.querySelector("[data-cart-fingerprint]");
          if (!stamp) {
            return theme.Drawer.refreshDrawerSection();
          }

          var items = Array.isArray(cart.items) ? cart.items : [];
          var actual =
            cart.item_count + ":" + cart.total_price + ":" + items.length;
          var numbersMatch =
            stamp.getAttribute("data-cart-fingerprint") === actual;

          // The numeric triple alone collides on same-total edits made in
          // another tab - swapping a line for an equal-priced product, or
          // moving it to an equal-priced selling plan. Both change the line
          // keys, which are already in the DOM as .cart-item[data-id], so
          // compare those too rather than stamping them a second time.
          var renderedKeys = Array.prototype.map
            .call(wrapper.querySelectorAll(".cart-item"), function (el) {
              return el.getAttribute("data-id");
            })
            .join(",");
          var actualKeys = items
            .map(function (item) {
              return item.key;
            })
            .join(",");

          if (numbersMatch && renderedKeys === actualKeys) return;

          // Returned, not fire-and-forget: addToCartOkay defers the
          // suggestion build on this promise, and "reconciled" must mean the
          // swap has actually landed, not merely that /cart.js answered.
          return theme.Drawer.refreshDrawerSection();
        })
        .catch(function () {});
    },

    refreshDrawerSection: function () {
      var params = theme.Drawer.getSectionRequestParams();
      if (!params || !params.id) return;

      var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      var generation = theme.Drawer.renderGeneration;
      return getText(root + "?section_id=" + params.id)
        .then(function (html) {
          // Rendered server-side before this fetch was issued. If a mutation
          // (or a newer refresh) has swapped the drawer since, this HTML is
          // already stale and would resurrect the lines it just replaced.
          if (theme.Drawer.renderGeneration !== generation) return;

          if (theme.Drawer.replaceDrawerContent(html)) {
            theme.Drawer.restoreProductRecommendation();
          }
        })
        .catch(function () {});
    },

    addToCartOkay: function (product) {
      var updateResult = theme.Drawer.applyCartUpdate(product);

      // /cart/add.js returns the added line item, which never carries
      // item_count, so the bubble (and, if the sections payload was missing,
      // the drawer itself) is settled by the reconcile fetch.
      var reconciled = null;
      if (!updateResult.hasCount) {
        reconciled = theme.Drawer.reconcileCart();
      }

      // Suggestions are keyed off the item that was just added. When the add
      // response carried a sections payload the drawer is already current, so
      // build immediately; when it did not, the DOM is still the pre-add
      // render, and building now would let the in-cart filter read stale
      // lines - wait for the reconcile swap instead.
      if (updateResult.sectionUpdated || !reconciled) {
        theme.Drawer.buildProductRecommendation(product);
      } else {
        reconciled.then(function () {
          theme.Drawer.buildProductRecommendation(product);
        });
      }

      theme.Drawer.openDrawer();
    },

    changeCartCount: function (cart_items) {
      cart_items = parseInt(cart_items, 10);
      var count = document.querySelector("#CartButton .cart-count-js");
      var bubble = document.querySelector("#CartButton .header__cart__count");

      if (cart_items > 0) {
        if (count) count.textContent = cart_items;
        if (bubble) {
          bubble.style.display = "";
          if (window.getComputedStyle(bubble).display === "none") {
            bubble.style.display = "block";
          }
          bubble.classList.add("pulse-cart-icon");
          setTimeout(function () {
            bubble.classList.remove("pulse-cart-icon");
          }, 800);
        }
      } else if (bubble) {
        bubble.style.display = "none";
      }
    },

    cartReloadPageRefresh: function () {
      var bubble = document.querySelector("#CartButton .header__cart__count");
      if (bubble) bubble.style.display = "none";
      theme.Drawer.reconcileCart();
    },

    cartCheck: function () {},

    showDrawer: function () {
      theme.Drawer.openDrawer();
    },

    // Fetch a product's pairs-with view (templates/product.pairs-with.liquid).
    // Deliberately NO Accept: application/json header - that header makes
    // Shopify content-negotiate the canonical product JSON and skip the view
    // template. Through Shopify.routes.root, so on translated storefronts
    // (/es/ and /fr/ are live) titles, urls and prices stay in the shopper's
    // locale and market end to end. On a market where the product is not
    // published this 404s, which callers treat as "skip this candidate"; on
    // a deploy where the template is missing Shopify serves the product PAGE,
    // the JSON parse yields null, and callers bail without rendering.
    getPairsWithView: function (handle) {
      var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      return requestJson(root + "products/" + handle + "?view=pairs-with", {
        credentials: "same-origin",
      });
    },

    // Render up to `limit` cards from pairs-with card payloads. Cards arrive
    // market-scoped, availability-filtered and cart-excluded server-side;
    // the guards here only skip payloads the card cannot draw (no image) or
    // that were computed before the cart last changed (in_cart).
    renderSuggestionCards: function (cards, limit) {
      if (!Array.isArray(cards)) return 0;
      var max = limit || 2;
      var shown = 0;
      for (var i = 0; i < cards.length && shown < max; i++) {
        var card = cards[i];
        if (
          !card ||
          !card.available ||
          card.in_cart ||
          !card.image ||
          !card.variant_id
        ) {
          continue;
        }
        theme.Drawer.addProductRecommendation({
          title: card.title,
          url: card.url,
          price: card.price,
          id: card.variant_id,
          image: card.image,
        });
        shown++;
      }
      return shown;
    },

    // Resolve recommendation candidates one at a time through the pairs-with
    // view - it carries the alternate title (styling HTML intact, translated
    // per locale), the server-checked in_cart flag, and 404s for products not
    // published in the shopper's market - until two cards render or the list
    // runs out. Sequential on purpose: it stops fetching as soon as the two
    // slots are filled.
    renderCandidateCards: function (
      candidates,
      index,
      shown,
      generation,
      done,
    ) {
      if (
        generation !== theme.Drawer.recGeneration ||
        shown >= 2 ||
        index >= candidates.length
      ) {
        if (typeof done === "function") done(shown);
        return;
      }
      var candidate = candidates[index];
      theme.Drawer.getPairsWithView(candidate.handle)
        .then(function (payload) {
          var added = 0;
          if (
            generation === theme.Drawer.recGeneration &&
            payload &&
            payload.card
          ) {
            // Keep the recommendations endpoint's own URL on the card: it
            // carries the ?pr_prod_strat attribution params that feed
            // Shopify's recommendation analytics. Everything else (alternate
            // title, price, image, in_cart) comes from the view.
            if (candidate.url) payload.card.url = candidate.url;
            added = theme.Drawer.renderSuggestionCards([payload.card], 1);
          }
          theme.Drawer.renderCandidateCards(
            candidates,
            index + 1,
            shown + added,
            generation,
            done,
          );
        })
        .catch(function () {
          theme.Drawer.renderCandidateCards(
            candidates,
            index + 1,
            shown,
            generation,
            done,
          );
        });
    },

    buildProductRecommendation: function (product) {
      var suggestedContainer = document.querySelector(
        ".suggested-product-container",
      );
      var suggestedWrapper = document.querySelector(
        ".drawer-footer-suggested-products",
      );
      if (!suggestedContainer || !product || !product.handle) return;

      var handle = product.handle;

      // Back to hidden and empty. addProductRecommendation reveals the block
      // again only once a card actually lands, so adding a product that has
      // no suggested: tags cannot leave the heading stranded above an empty
      // list (restoreProductRecommendation may just have re-shown it).
      suggestedContainer.innerHTML = "";
      theme.Drawer.suggestedHtml = "";
      theme.Drawer.collectionFallbackCards = [];
      if (suggestedWrapper) suggestedWrapper.style.display = "none";

      var generation = ++theme.Drawer.recGeneration;

      // The ladder: suggested: tags -> complementary recommendations ->
      // related recommendations -> the product's most specific collection.
      // The pairs-with view resolves the first and last rungs server-side
      // (tag parsing, alternate titles with their styling HTML, market
      // scoping, live-cart exclusion), so this one fetch both answers the
      // tag path and pre-loads the collection fallback for the case where
      // every recommendation rung comes up dry.
      theme.Drawer.getPairsWithView(handle)
        .then(function (payload) {
          // A newer build or an emptied cart superseded this fetch.
          if (generation !== theme.Drawer.recGeneration) return;
          if (!payload || !payload.id) return;

          var rendered = theme.Drawer.renderSuggestionCards(payload.suggested);
          if (rendered > 0) return;

          theme.Drawer.collectionFallbackCards = payload.collection || [];

          // Complementary first: it is the merchant-curated set (Search &
          // Discovery) and matches the block's localized
          // cart.pairs_with.heading copy; fetchShopifyRecommendations falls
          // back to the algorithmic related set when it comes back empty.
          theme.Drawer.fetchShopifyRecommendations(
            payload.id,
            "complementary",
            generation,
          );
        })
        .catch(function () {});
    },

    fetchShopifyRecommendations: function (productId, intent, generation) {
      if (!productId) return;
      var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      // limit=6, not 2: unavailable, imageless and already-in-cart candidates
      // are filtered below, so ask for headroom - still one request, and the
      // endpoint caps at 10.
      getJson(
        root +
          "recommendations/products.json?product_id=" +
          productId +
          "&limit=6&intent=" +
          intent,
      )
        .then(function (result) {
          // A newer build or an emptied cart superseded this fetch.
          if (generation !== theme.Drawer.recGeneration) return;
          var products = result && result.products;
          if (!Array.isArray(products)) products = [];

          // Cheap pre-filter before any per-candidate view fetch; the view
          // then supplies the alternate title, the live in_cart flag, and
          // 404s for candidates not published in this market.
          var candidates = [];
          for (var i = 0; i < products.length; i++) {
            if (products[i] && products[i].available && products[i].handle) {
              candidates.push({
                handle: products[i].handle,
                url: products[i].url,
              });
            }
          }

          theme.Drawer.renderCandidateCards(
            candidates,
            0,
            0,
            generation,
            function (shown) {
              if (generation !== theme.Drawer.recGeneration || shown > 0) {
                return;
              }
              if (intent === "complementary") {
                // Complementary unconfigured for this product (or every
                // candidate filtered out): try the algorithmic set once.
                theme.Drawer.fetchShopifyRecommendations(
                  productId,
                  "related",
                  generation,
                );
              } else {
                // Both recommendation rungs dry: last resort is the
                // product's own collection, pre-computed by the view.
                theme.Drawer.renderSuggestionCards(
                  theme.Drawer.collectionFallbackCards,
                );
              }
            },
          );
        })
        .catch(function () {
          // Endpoint failure (404 unpublished, 422, network): skip straight
          // to the collection fallback rather than retrying an endpoint that
          // will fail the same way for the other intent.
          if (generation !== theme.Drawer.recGeneration) return;
          theme.Drawer.renderSuggestionCards(
            theme.Drawer.collectionFallbackCards,
          );
        });
    },

    addProductRecommendation: function (product) {
      var suggestedContainer = document.querySelector(
        ".suggested-product-container",
      );
      var suggestedWrapper = document.querySelector(
        ".drawer-footer-suggested-products",
      );
      if (!suggestedContainer || !suggestedWrapper) return;

      if (!product.image) return;

      var title = product.title;
      var url = product.url;
      var price = slate.Currency.formatMoney(product.price, theme.moneyFormat);
      // Already sized by the pairs-with view (image_url 160x160 center-crop,
      // 2x the 80px slot) - used verbatim, no client-side resize pass.
      var img = product.image;
      var id = product.id;
      var add_label = theme.strings.cart_pairs_with.add;

      var suggestedProductTemplate =
        `<div class="suggested-product">
                <div class="suggested-product-content">
                  <img height="70" width="70" src="` +
        img +
        `">
                  <div class="suggested-product-text">
					<a href="` +
        url +
        `">
                    <p class="suggested-product-title">` +
        title +
        `</p>
					</a>
                    <p class="suggested-product-price">` +
        price +
        `</p>
                  </div>
                </div>
				<a data-id="` +
        id +
        `" class="product-grid-add-js">
                <button class="suggested-product-cta" >
                  ` +
        add_label +
        `
                </button>
				</a>
              </div>`;

      suggestedContainer.insertAdjacentHTML(
        "beforeend",
        suggestedProductTemplate,
      );
      suggestedWrapper.style.display = "";
      theme.Drawer.suggestedHtml = suggestedContainer.innerHTML;
    },

    // Re-attach the cached cards after the Section Rendering API swaps in a
    // freshly rendered (and therefore empty) suggestions container.
    restoreProductRecommendation: function () {
      if (!theme.Drawer.suggestedHtml) return;

      var suggestedContainer = document.querySelector(
        ".suggested-product-container",
      );
      var suggestedWrapper = document.querySelector(
        ".drawer-footer-suggested-products",
      );
      if (!suggestedContainer || !suggestedWrapper) return;

      suggestedContainer.innerHTML = theme.Drawer.suggestedHtml;
      suggestedWrapper.style.display = "";
    },

    closeDrawer: function () {
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper) return;

      drawerWrapper.classList.add("closing");

      // A11y: reflect collapsed state and return focus to the trigger (the cart button).
      var cartBtn = document.querySelector("#CartButton");
      if (cartBtn) cartBtn.setAttribute("aria-expanded", "false");
      var returnTarget = theme.Drawer._trigger || cartBtn;
      if (returnTarget && returnTarget.focus) {
        returnTarget.focus({ preventScroll: true });
      }

      setTimeout(function () {
        document.body.classList.remove("drawer-open");
        document.documentElement.classList.remove("drawer-open");

        drawerWrapper.classList.add("close");
        drawerWrapper.classList.remove("open");
        drawerWrapper.classList.remove("closing");

        window.removeEventListener("click", theme.Drawer.handleClickOutside);
      }, 800);

      var drawerMain = document.querySelector(".drawer-main");
      if (window.bodyScrollLock && drawerMain) {
        bodyScrollLock.enableBodyScroll(drawerMain);
      }
    },

    openDrawer: function () {
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper || drawerWrapper.classList.contains("open")) return;

      if (window.theme && theme.ChatWidget && theme.ChatWidget.hide) {
        theme.ChatWidget.hide();
      }

      drawerWrapper.classList.remove("close");
      document.body.classList.add("drawer-open");
      document.documentElement.classList.add("drawer-open");
      drawerWrapper.classList.add("open");

      // A11y: reflect open state on the trigger and move focus into the top of the drawer.
      var cartBtn = document.querySelector("#CartButton");
      if (cartBtn) {
        theme.Drawer._trigger = cartBtn;
        cartBtn.setAttribute("aria-expanded", "true");
      }
      setTimeout(function () {
        var closeEl = drawerWrapper.querySelector(".drawer-close");
        if (closeEl) closeEl.focus({ preventScroll: true });
      }, 0);

      window.addEventListener("click", theme.Drawer.handleClickOutside);

      var drawerMain = document.querySelector(".drawer-main");
      if (window.bodyScrollLock && drawerMain) {
        bodyScrollLock.disableBodyScroll(drawerMain);
      }
    },

    handleClickOutside: function (e) {
      if (
        !closest(e.target, ".drawer-main") &&
        document.documentElement.classList.contains("drawer-open")
      ) {
        theme.Drawer.closeDrawer();
      }
    },
  };

  document.addEventListener("click", function (e) {
    var closeBtn = closest(e.target, ".drawer-close");
    if (closeBtn) {
      e.preventDefault();
      theme.Drawer.closeDrawer();
      return;
    }

    var cartButton = closest(e.target, "#CartButton");
    if (cartButton) {
      e.preventDefault();
      theme.Drawer.openDrawer();
      e.stopPropagation();
      return;
    }

    var removeBtn = closest(e.target, ".cart-item-remove-container");
    if (removeBtn) {
      e.preventDefault();
      if (theme.Drawer && theme.Drawer.isUpdating) {
        return;
      }
      var cartItem = closest(removeBtn, ".cart-item");
      if (!cartItem) return;
      var key = cartItem.getAttribute("data-id");
      var data = { quantity: 0, id: key };

      theme.Drawer.setLoadingState(true);

      var fail = function (error) {
        console.log("error: ", error);
        var errorMessage =
          (error.responseJSON && error.responseJSON.message) || "";
        var errorText = cartItem.querySelector(".js-cart-item-error-text");
        if (errorText) errorText.textContent = errorMessage;
        cartItem.classList.add("has-error");
      };

      var finallyCb = function () {
        theme.Drawer.setLoadingState(false);
      };

      var success = function (cart) {
        var result = theme.Drawer.applyCartUpdate(cart);
        if (!result.sectionUpdated) theme.Drawer.reconcileCart();
      };

      cartItemChangeQty(data, success, fail, finallyCb);
      return;
    }

    var qtyAdjust = closest(e.target, ".drawer-qty-adjust");
    if (qtyAdjust) {
      e.preventDefault();
      if (theme.Drawer && theme.Drawer.isUpdating) {
        return;
      }

      var qtySelector = qtyAdjust.parentElement
        ? qtyAdjust.parentElement.querySelector(".js-qty__num.quantity__input")
        : null;
      if (!qtySelector) return;

      var qty = parseInt(qtySelector.value.replace(/\D/g, ""), 10);
      var cartItem = closest(qtyAdjust, ".cart-item");

      qtySelector.dataset.oldValue = qty;

      if (parseFloat(qty) !== parseInt(qty, 10) || isNaN(qty)) {
        qty = 1;
      }

      if (qtyAdjust.classList.contains("quantity__minus")) {
        qty = qty - 1;
      } else {
        qty = qty + 1;
      }

      qtySelector.value = qty;
      qtySelector.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  document.addEventListener("change", function (e) {
    var qtyInput = closest(e.target, ".js-qty__num.quantity__input");
    if (!qtyInput) return;

    if (theme.Drawer && theme.Drawer.isUpdating) {
      return;
    }

    var qty = qtyInput.value;
    var qtyAdjust = qtyInput.parentElement
      ? qtyInput.parentElement.querySelectorAll(".js-drawer-qty-adjust")
      : [];
    var cartItem = closest(qtyInput, ".cart-item");
    if (!cartItem) return;

    var key = cartItem.getAttribute("data-id");
    var data = { quantity: qty, id: key };

    qtyInput.disabled = true;
    qtyAdjust.forEach(function (btn) {
      btn.disabled = true;
    });

    cartItem.classList.remove("has-error");

    var fail = function (error) {
      var oldValue = qtyInput.dataset.oldValue;
      if (oldValue !== undefined) {
        qtyInput.value = oldValue;
      }

      console.log("error: ", error);

      var errorMessage =
        (error.responseJSON && error.responseJSON.message) || "";

      var errorText = cartItem.querySelector(".js-cart-item-error-text");
      if (errorText) errorText.textContent = errorMessage;

      cartItem.classList.add("has-error");
    };

    var finallyCb = function () {
      qtyInput.disabled = false;
      qtyAdjust.forEach(function (btn) {
        btn.disabled = false;
      });
      theme.Drawer.setLoadingState(false);
    };

    var success = function (cart) {
      var result = theme.Drawer.applyCartUpdate(cart);
      if (!result.sectionUpdated) theme.Drawer.reconcileCart();
    };

    theme.Drawer.setLoadingState(true);
    cartItemChangeQty(data, success, fail, finallyCb);
  });

  window.addEventListener("load", function () {
    theme.Drawer.cartReloadPageRefresh();
  });

  window.addEventListener("pageshow", function (event) {
    var historyPage =
      event.persisted ||
      (typeof window.performance !== "undefined" &&
        window.performance.navigation.type === 2);
    if (historyPage) {
      theme.Drawer.cartReloadPageRefresh();
    }
  });
})();
